import { render, staticRenderFns } from "./AssociatedTags.vue?vue&type=template&id=366db9e2&scoped=true"
import script from "./AssociatedTags.vue?vue&type=script&lang=js"
export * from "./AssociatedTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366db9e2",
  null
  
)

export default component.exports